<template>
    <v-app>

        <NavBar/>
        
        <v-content>
            <v-container fluid class="px-0 py-0">
                <v-row align="center" justify="center" class="mx-0 px-0">
                    <v-col md="5" sm="12" xs="12" class="py-0 px-0">
                        <v-card elevation="10">
                            <v-card-text class="px-0 py-0" justify="center" align="center">
                                <v-row style="max-width:100%">
                                    <v-col cols="12" class="px-0 py-0">

                                        <Inicio v-if="$store.state.tipoElegido === 'Inicio'"/>
                                        
                                        <Localidad v-if="$store.state.tipoElegido === 'Localidad'"/>
                                        <Comercio v-if="$store.state.tipoElegido === 'Comercio'"/>
                                        <ComercioPDF v-if="$store.state.tipoElegido === 'ComercioPDF'"/>

                                        <LectorQR v-if="$store.state.tipoElegido === 'LectorQR'"/>
                                        <LectorQRExt v-if="$store.state.tipoElegido === 'LectorQRExt'"/>
                                        <Contacto v-if="$store.state.tipoElegido === 'Contacto'"/>
                                        <MasInfo v-if="$store.state.tipoElegido === 'MasInfo'"/>
                                        

                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

            </v-container>
        </v-content>

        <Footer/>

    </v-app>
</template>

<script>
    import Inicio from '@/views/Inicio.vue';
    import Localidad from '@/views/Localidad.vue';
    import Comercio from '@/views/Comercio.vue';
    import ComercioPDF from '@/views/ComercioPDF.vue';
    import LectorQR from '@/views/LectorQR.vue';
    import LectorQRExt from '@/views/LectorQRExt.vue';
    import MasInfo from '@/views/MasInfo.vue';
    import Contacto from '@/views/Contacto.vue';
    import NavBar from '@/components/NavBar.vue';
    import Footer from '@/components/Footer.vue';
    import store from './store/index';
    import { alergenos_api } from '@/api/alergenos';
    import { categorias_api } from '@/api/categorias';
    import { ciudad_api } from '@/api/ciudades';
    import { comercio_api } from '@/api/comercio';
    import { platos_api } from '@/api/platos';

    export default {
        data () {
            return {
                primaryDrawer: {
                    model: null,
                    type: 'temporary',
                    clipped: false,
                    floating: false,
                    mini: false,
                },
                footer: {
                    inset: false,
                },
                comercio: '',
                ciudad: '',
                dev: '',
                urlBase: this.$store.state.url_base,
                tipoVista: this.$store.state.tipoElegido
            }
        },
        components: {
            NavBar,
            Footer,
            Inicio,
            Localidad,
            Comercio,
            ComercioPDF,
            LectorQR,
            LectorQRExt,
            Contacto,
            MasInfo,
        },
        beforeCreate () {
            var slug = window.location.pathname.substr(1);   
            
            if(slug) {
                 if(slug === 'lectorqr'){
                    this.$store.commit("cambiarCiudadID", '');
                    this.$store.commit("cambiarCiudadSlug", '');
                    this.$store.commit("cambiarComercioID", '');
                    this.$store.commit("cambiarComercioSlug", '');
                    this.$store.commit("cambiarLectorQRExt", '');
                    this.$store.commit("cambiarTipo", "LectorQR");
                } else if(slug === 'masinfo'){
                    this.$store.commit("cambiarCiudadID", '');
                    this.$store.commit("cambiarCiudadSlug", '');
                    this.$store.commit("cambiarComercioID", '');
                    this.$store.commit("cambiarComercioSlug", '');
                    this.$store.commit("cambiarLectorQRExt", '');
                    this.$store.commit("cambiarTipo", "MasInfo");
                } else {
                    //Comprobamos si el slug es un pueblo
                    ciudad_api.getCiudadSlug(slug)
                    .then( res => {
                        this.ciudad = res
                        
                        if(Object.keys(this.ciudad).length > '0') {
                            this.$store.commit("cambiarCiudadID", this.ciudad[0].id);
                            this.$store.commit("cambiarCiudadSlug", slug);
                            this.$store.commit("cambiarTipo", "Localidad");
                        }
                        else{
                            //No es un pueblo. Vamos a comprobar que no sea un comercio
                            comercio_api.getComercioSlug(slug)
                            .then( res => {
                                this.comercio = res

                                if(Object.keys(this.comercio).length > '0') {
                                    this.$store.commit("cambiarComercioID", this.comercio[0].id);
                                    this.$store.commit("cambiarComercioSlug", slug);
                                    this.$store.commit("cambiarTipo", "Comercio");
                                }
                                else 
                                {
                                    // No es ninguno de los dos, vamos a la pagina de Inicio
                                    this.$store.commit("cambiarCiudadID", '');
                                    this.$store.commit("cambiarCiudadSlug", '');
                                    this.$store.commit("cambiarComercioID", '');
                                    this.$store.commit("cambiarComercioSlug", '');
                                    this.$store.commit("cambiarLectorQRExt", '');
                                    this.$store.commit("cambiarTipo", "Inicio");
                                    window.location.href = this.urlBase;
                                }
                            })
                        }
                    });
                }
            }            

        },
        methods: {
            
        },
    };
</script>
